import {createBrowserHistory, createMemoryHistory} from 'history';
import EnvironmentUtils from '@spothero/utils/environment';

export default EnvironmentUtils.isBrowser()
    ? createBrowserHistory
    : createMemoryHistory;
